import { init } from "../init";
import { JiraServiceManagementSoftwarePage } from "../pages/software/jira/service-management/anchors/jira-service-management-software-page";
init(JiraServiceManagementSoftwarePage);
